<ng-select
        (change)="onChange($event)"
        [(ngModel)]="academicYearValue"
        [items]="academicYears"
        [loading]="loading"
        [multiple]="false"
        [bindLabel]="group_by_period ? 'period_name' : 'academic_year'"
        [bindValue]="group_by_period ? 'period_id' : 'academic_year'"
        [groupBy]="group_by_period ? 'academic_year' : undefined"
        [disabled]="isDisabled"
        [clearable]="clear"
        [placeholder]="academicYearValue ? '' : ((all ? 'ALL' : 'SELECT') | translate) + ' ' + ('ACADEMIC_YEAR' | translate)"
        class="selector-style">

    <ng-template ng-optgroup-tmp let-item="item" let-item$="item$">
        <div class="group-style">
            {{ item?.academic_year || ('ACADEMIC_YEAR' | translate) }}
        </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item">
        <div class="custom-option-style" [ngClass]="{'disabled-option': isDisabled}">
            {{ group_by_period ? (item.period_name || item.academic_year || 'Unnamed group') : (item.academic_year || 'Unnamed group') }}
        </div>
    </ng-template>
</ng-select>
